module.exports = __webpack_public_path__ + "static/media/logo_m.82fc5921.png";